import { useState, useEffect } from 'react';

export const useCarousel = (itemCount, autoRotateInterval = 5000, startIndex = 0) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex);
  const [isAutoRotating, setIsAutoRotating] = useState(true);

  useEffect(() => {
    if (!isAutoRotating || itemCount === 0) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % itemCount);
    }, autoRotateInterval);

    return () => clearInterval(timer);
  }, [isAutoRotating, itemCount, autoRotateInterval]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoRotating(false);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % itemCount);
    setIsAutoRotating(false);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + itemCount) % itemCount);
    setIsAutoRotating(false);
  };

  const resumeAutoRotate = () => {
    setIsAutoRotating(true);
  };

  return {
    currentIndex,
    goToSlide,
    nextSlide,
    prevSlide,
    isAutoRotating,
    resumeAutoRotate
  };
};
